export default {
  title: {
    id: 'asp_sharing_media_attached_files',
    defaultMessage: 'Attached files',
  },
  description: {
    id: 'bo_sellers_customer_care_request_details_attachments_description',
    defaultMessage: `{count, plural,
      =0 {No attachments}
      one {# attachment}
      other {# attachments}
    }`,
  },
  noAttachmentText: {
    id: 'bo_sellers_customer_care_request_details_attachments_no_attachment_text',
    defaultMessage: 'No attachments added',
  },
  notification: {
    id: 'asp_sharing_media_shared_files_notification',
    defaultMessage: 'Shared files',
  },
}
